import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import classNames from 'classnames';
import classes from './NavF.module.scss';

const NavF = (props) => {
  const {
    header, link, nodes,
  } = props;

  const isLink = link && link.href;
  const linkTitle = isLink && `(${link.title})`;

  return (
    <div className={classes.container}>
      <div className={classes.wrapper}>
        <div className={classes.innerContainer}>
          {header && <div
            className={classes.header}
            dangerouslySetInnerHTML={{ __html: header }}
          />}
          {isLink &&
            <Link
              href={link.href}
              target={link.target}
              className={classes.link}
              dangerouslySetInnerHTML={{ __html: linkTitle }}
            />}
          {nodes && nodes.length > 0 &&
          <div className={classes.linkList}>
            {nodes.map((node) => (
              <Link
                href={node.url}
                target={node.linkTarget}
                className={classNames(classes.navItem, { [classes.active]: node.isActive })}
                key={node.url}
                dangerouslySetInnerHTML={{ __html: node.title }}
              />
            ))}
          </div>}
        </div>
      </div>
    </div>
  );
};

NavF.propTypes = {
  /**
   * Text displays at the top of the component
  */
  header: PropTypes.string,
  /**
   * A list of links that display directly below the header
  */
  link: PropTypes.object,
  /**
   * A link that displays to the right of the header
  */
  nodes: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string,
    linkTarget: PropTypes.string,
    title: PropTypes.string,
    isActive: PropTypes.bool,
  })),
};

export default NavF;
